<template>
  <modalWindow @close="closeModal()" width="400">
    <div class="titlebar">
      {{ uploadForm ? 'Veilig bestanden uploaden' : 'Contact opnemen' }}
    </div>
    <template v-if="!uploadForm">
      <div class="form-notice" v-if="msg.type != 'success'">
        U kunt ons ook bellen op
        <a v-if="style=='ox'" href="tel://020-5550000" class="phonelink">020 - 555 0000</a>
        <a v-else-if="style=='vm'" href="tel://020-3449144" class="phonelink">020 - 344 9144</a>
        <a v-else-if="style=='bvs'" href="tel://020-5707808" class="phonelink">020 - 570 7808</a>
        <a v-else href="tel://020-5550055" class="phonelink">020 - 555 0055</a>.
      </div>
      <span v-if="msg.msg" :class="[`form-${msg.type}`]">{{ msg.msg }}</span>
      <form @submit.prevent v-if="msg.type != 'success'" class="inset">
        <select v-model="contactOption" ref="option" @change="changeQuestion">
          <option
            v-for="(contact, index) in contactSubjects"
            :key="index"
            :value="contact"
          >
            {{ contact.label }}
          </option>
        </select>
        <select v-model="selectedQuestion" ref="selectedQuestion">
          <option
            v-for="(question, index) in filter(
              questionList,
              (o) => o.type === contactOption.value || o.value === 'Kies een onderwerp',
            )"
            :key="index"
            :value="question"
          >
            {{ question.value }}
          </option>
        </select>
        <div v-if="selectedQuestion.extra !== ''" style="margin: 10px 0 0 0;font-style: italic;">
          {{ selectedQuestion.extra }}
        </div>
        <input
          v-if="selectedQuestion.value === 'Anders'"
          v-model="otherSubject" placeholder="Vul uw onderwerp in..."
        >
        <textarea
          v-model="message"
          :placeholder="variablePlaceholder(selectedQuestion.value)"
          rows="8"
        />
        <input type=submit @click="contact" value="Bericht versturen">
      </form>
    </template>
    <template v-else>
      <div class="form-notice" v-if="tooltipText">
        {{ tooltipText }}
      </div>
      <div class="inset" v-if="$store.state.currentView === 'Intake'">
        <p class="subheader">
          U kunt hieronder klikken op 'Kies een bestand' om een bestand toe te voegen aan uw
          vragenlijst.
        </p>
        <customInput
          v-model="$parent.intake.rekeningData.genericFiles"
          type="file"
          prefix="generic"
          :validation="['files', 'notrequired']"
        />
      </div>
      <div class="inset" v-else>
        <label
          for="contactuploadfile" class="file-label button"
          style="display:block;height:initial;"
        >
          <awesomeIcon icon="upload"/> Bestanden uploaden
        </label>
        <input
          style="display:none" ref="files" id="contactuploadfile"
          type="file" name="img" multiple @change="uploadFilesChanged"
        >
      </div>
    </template>
    <template v-if="msg.type != 'success'">
      <a class="block-button" @click="uploadForm = true" v-if="!uploadForm">
        <awesomeIcon icon="upload"/> Veilig bestanden uploaden
      </a>
      <a class="block-button" @click="uploadForm = false" v-else>
        <awesomeIcon icon="chevron-left"/> Terug
      </a>
    </template>
  </modalWindow>
</template>

<script>
import { find, filter } from 'lodash-es';

export default {
  data() {
    return {
      selectedQuestion: null,
      contactOption: null,
      message: '',
      msg: { msg: null, type: 'notice' },
      style: process.env.VUE_APP_STYLE,
      tooltipText: '',
      uploadForm: false,
      subject: null,
      otherSubject: null,
      questionList: [
        {
          value: 'Kies een onderwerp',
          extra: '',
        },
        {
          value: 'Ik heb een algemene vraag',
          type: 'Algemeen',
          extra: '',
        },
        {
          value: 'Ik wil graag gebeld worden',
          type: 'Algemeen',
          extra: '',
        },
        {
          value: 'Mijn kind is (bijna) 18 jaar',
          type: 'Algemeen',
          extra: 'U kunt het e-mailadres van uw kind hieronder aangeven.',
        },
        {
          value: 'Ik wil feedback geven',
          type: 'Algemeen',
          extra: '',
        },
        {
          value: 'Ik wil geld storten',
          type: 'Algemeen',
          extra: 'U kunt hiervoor gebruik maken van de ‘Bijstorten’ functie (iDeal) onder de Portefeuille widget. Of u kunt zelf geld overmaken naar IBAN-nummer: NL85ABNA0426198212 ten name van Stichting Collectieve Beleggersgiro. O.v.v. uw bovenstaande rekeningnummer',
        },
        {
          value: 'Ik wil al mijn rekeningen opheffen',
          type: 'Algemeen',
          extra: 'Graag vernemen we van u waarom u uw rekening wilt opheffen. We willen met deze informatie onze dienstverlening verbeteren. Na een finale afrekening verkopen we de beleggingen en maken uw geld over naar uw tegenrekening. Dit kan een aantal dagen duren.',
        },
        {
          value: 'Ik wil mijn gebruiker verwijderen',
          type: 'Algemeen',
          extra: 'Indien u wenst om uw gebruiker te laten verwijderen, worden alle rekeningen die onder deze gebruiker vallen ook opgeheven. Graag vernemen we van u waarom u uw gebruiker wilt verwijderen. We willen met deze informatie onze dienstverlening verbeteren. Indien er rekeningen onder de account vallen, zal er na een finale afrekening de beleggingen verkocht worden en maken uw geld over naar uw tegenrekening. Dit kan een aantal dagen duren.',
        },
        {
          value: 'Ik wil een fout melden',
          type: 'Algemeen',
          extra: 'Probeer zo goed mogelijk het probleem te omschrijven zodat we de fout kunnen reproduceren. Graag willen we ook weten welk besturingssysteem en internetbrowser u gebruikt.',
        },
        {
          value: 'Ik wil graag overstappen naar Doelbeleggen.nl',
          type: 'Algemeen',
          extra: 'Met het versturen van dit bericht, verzoekt u ons om een start te maken met de overstap. Wij gaan voor u aan de slag.',
        },
        {
          value: 'Ik wil mijn e-mailadres wijzigen',
          type: 'Algemeen',
          extra: 'U kunt uw nieuwe e-mailadres hieronder aangeven.',
        },
        {
          value: 'Anders',
          type: 'Algemeen',
          extra: '',
        },
        {
          value: 'Ik wil mijn beleggingsprofiel wijzigen',
          type: 'port',
          extra: '',
        },
        {
          value: 'Ik wil een extra rekening aanvragen',
          type: 'port',
          extra: '',
        },
        {
          value: 'Mijn kind is (bijna) 18 jaar',
          type: 'port',
          extra: 'U kunt het e-mailadres van uw kind hieronder aangeven.',
        },
        {
          value: 'Ik wil starten met uitkeren',
          type: 'port',
          extra: '',
        },
        {
          value: 'Ik wil geld storten',
          type: 'port',
          extra: 'U kunt hiervoor gebruik maken van de ‘Bijstorten’ functie (iDeal) onder de Portefeuille widget. Of u kunt zelf geld overmaken naar IBAN-nummer: NL85ABNA0426198212 ten name van Stichting Collectieve Beleggersgiro. O.v.v. uw bovenstaande rekeningnummer',
        },
        {
          value: 'Ik wil meer dan 1000 euro onttrekken',
          type: 'port',
          extra: 'Beschrijf goed hoeveel geld u wilt onttrekken en wat de reden is. Wij gaan zo snel mogelijk aan de slag om het geld vrij te maken en het over te maken naar uw tegenrekening.LET OP: Bij een box 1 rekening kan onttrekken fiscale consequenties hebben.',
        },
        {
          value: 'Ik wil minder dan 1000 euro onttrekken',
          type: 'port',
          extra: 'Beschrijf goed hoeveel geld u wilt onttrekken en wat de reden is. Wij gaan zo snel mogelijk aan de slag om het geld vrij te maken en het over te maken naar uw tegenrekening.LET OP: Bij een box 1 rekening kan onttrekken fiscale consequenties hebben.',
        },
        {
          value: 'Ik wil deze rekening opheffen',
          type: 'port',
          extra: 'Graag vernemen we van u waarom u uw rekening wilt opheffen. We willen met deze informatie onze dienstverlening verbeteren. Na een finale afrekening verkopen we de beleggingen en maken uw geld over naar uw tegenrekening. Dit kan een aantal dagen duren.',
        },
        {
          value: 'Ik wil mijn e-mailadres wijzigen',
          type: 'port',
          extra: '',
        },
        {
          value: 'Ik wil een fout melden',
          type: 'port',
          extra: 'Probeer zo goed mogelijk het probleem te omschrijven zodat we de fout kunnen reproduceren. Graag willen we ook weten welk besturingssysteem en internetbrowser u gebruikt.',
        },
        {
          value: 'Anders',
          type: 'port',
          extra: '',
        },
        {
          value: 'Ik wil mijn beleggingsprofiel wijzigen',
          type: 'intake',
          extra: '',
        },
        {
          value: 'Ik wil geld storten',
          type: 'intake',
          extra: 'U kunt hiervoor gebruik maken van de ‘Bijstorten’ functie (iDeal) onder de Portefeuille widget. Of u kunt zelf geld overmaken naar IBAN-nummer: NL85ABNA0426198212 ten name van Stichting Collectieve Beleggersgiro. O.v.v. uw bovenstaande rekeningnummer',
        },
        {
          value: 'Ik wil een fout melden',
          type: 'intake',
          extra: 'Probeer zo goed mogelijk het probleem te omschrijven zodat we de fout kunnen reproduceren. Graag willen we ook weten welk besturingssysteem en internetbrowser u gebruikt.',
        },
        {
          value: 'Anders',
          type: 'intake',
          extra: '',
        },
      ],
    };
  },
  props: {
    intake: {
      default: -1,
      type: Number,
    },
    preselectedSubject: {
      default: '',
      type: String,
    },
  },
  computed: {
    contactSubjects() {
      const subjects = [
        {
          id: null,
          label: 'Algemeen',
          value: 'Algemeen',
        },
      ];
      for (let i = 0; i < this.$store.state.ports.length; i += 1) {
        if (this.$store.state.currentView === 'Dashboard' && this.$store.state.currentPort && (Number(this.$store.state.ports[i].id) === Number(this.$store.state.currentPort))) {
          subjects.push(
            {
              id: this.$store.state.ports[i].id,
              value: 'port',
              label: `Betreft portefeuille ${this.$store.state.ports[i].id} (huidige)`,
            },
          );
        } else {
          subjects.push(
            {
              id: this.$store.state.ports[i].id,
              value: 'port',
              label: `Betreft portefeuille ${this.$store.state.ports[i].id}`,
            },
          );
        }
      }
      for (let i = 0; i < this.$store.state.intakes.length; i += 1) {
        if (this.$store.state.currentView === 'Intake'
            && this.intake !== -1
            && Number(this.$store.state.intakes[i].id) === this.intake) {
          subjects.push(
            {
              id: this.$store.state.intakes[i].id,
              value: 'intake',
              label: `Betreft vragenlijst #${this.$store.state.intakes[i].id} (huidige)`,
            },
          );
        } else {
          subjects.push(
            {
              id: this.$store.state.intakes[i].id,
              value: 'intake',
              label: `Betreft vragenlijst #${this.$store.state.intakes[i].id}`,
            },
          );
        }
      }
      return subjects;
    },
    currentPort() {
      return find(this.$store.state.ports, {
        id: this.$store.state.currentPort,
      });
    },
  },
  created() {
    // eslint-disable-next-line
    this.selectedQuestion = this.questionList[0];
    this.openContactModal();
  },
  methods: {
    filter,
    changeQuestion() {
      if (this.contactOption.value !== this.selectedQuestion.type) {
        // eslint-disable-next-line
        this.selectedQuestion = this.questionList[0];
      }
    },
    openContactModal() {
      // eslint-disable-next-line
      this.contactOption = this.contactSubjects[0];
      if (this.$store.state.currentView === 'Dashboard' && this.$store.state.currentPort) {
        for (let i = 0; i < this.$store.state.ports.length; i += 1) {
          if (Number(this.$store.state.ports[i].id) === Number(this.$store.state.currentPort)) {
            this.contactOption = {
              id: this.$store.state.ports[i].id,
              value: 'port',
              label: `Betreft portefeuille ${this.$store.state.ports[i].id} (huidige)`,
            };
          }
        }
      } else if (this.$store.state.currentView === 'Intake') {
        for (let i = 0; i < this.$store.state.intakes.length; i += 1) {
          if (Number(this.$store.state.intakes[i].id) === this.intake) {
            this.contactOption = {
              id: this.$store.state.intakes[i].id,
              value: 'intake',
              label: `Betreft vragenlijst #${this.$store.state.intakes[i].id} (huidige)`,
            };
          }
        }
      }
      if (this.preselectedSubject) {
        this.contactOption = {
          id: null,
          label: 'Algemeen',
          value: 'Algemeen',
        };
        this.selectedQuestion = find(
          this.questionList,
          (o) => o.value === this.preselectedSubject,
        );
      }
    },
    variablePlaceholder(subject) {
      if (subject === 'Ik wil mijn e-mailadres wijzigen') {
        return 'U kunt uw nieuwe e-mailadres hieronder aangeven...';
      }
      if (subject === 'Mijn kind is (bijna) 18 jaar') {
        return 'Vul hier het e-mailadres van uw kind in...';
      }
      if (subject === 'Ik wil feedback geven') {
        return 'Vul hier uw feedback in...';
      }
      if (
        subject === 'Ik wil meer dan 1000 euro onttrekken'
        || subject === 'Ik wil minder dan 1000 euro onttrekken'
      ) {
        return 'Geef hier aan hoeveel u wilt onttrekken en de reden hiervan...';
      }
      if (subject === 'Ik wil deze rekening opheffen') {
        return 'Geef hier (eventueel) aan waarom u uw rekening wilt opheffen...';
      }
      if (subject === 'Ik wil al mijn rekeningen opheffen') {
        return 'Geef hier (eventueel) aan waarom u al uw rekening wilt opheffen...';
      }
      if (subject === 'Ik wil mijn gebruiker verwijderen') {
        return 'Geef hier (eventueel) aan waarom u uw gebruiker wilt verwijderen...';
      }
      if (subject === 'Ik wil een fout melden') {
        return 'Ik wil een fout melden...';
      }
      if (subject === 'Ik wil graag overstappen naar Doelbeleggen.nl') {
        return 'U kunt hier eventueel nog uw vragen stellen...';
      }
      return 'Stel hier uw vraag...';
    },
    uploadFilesChanged(e) {
      this.uploadFiles(e.target.files.length);
    },
    uploadFiles() {
      this.sdk.addFile(
        this.$refs.files.files,
        (response) => {
          if (response.status === 200) {
            // success
            this.tooltipText = 'We hebben uw bestanden ontvangen.';
          } else {
            this.tooltipText = 'Fout met uploaden. Wij accepteren alleen afbeeldingen en pdf bestanden.';
          }
        },
        this.$store.state.currentPort,
      );
    },
    contact() {
      let mandatoryMessage = true;
      if (
        this.selectedQuestion
        && (
          this.selectedQuestion.value === 'Ik wil deze rekening opheffen'
          || this.selectedQuestion.value === 'Ik wil al mijn rekeningen opheffen'
          || this.selectedQuestion.value === 'Ik wil mijn gebruiker verwijderen'
          || this.selectedQuestion.value === 'Ik wil graag overstappen naar Doelbeleggen.nl'
        )
      ) {
        mandatoryMessage = false;
      }
      if (!this.contactOption) {
        // No question selected
        this.msg = { msg: 'Het bericht kan niet worden verzonden, kies waar uw vraag over gaat', type: 'error' };
      } else if (this.selectedQuestion.value === this.questionList[0].value) {
        // no subject selected
        this.msg = { msg: 'Het bericht kan niet worden verzonden, kies A.U.B. een onderwerp', type: 'error' };
      } else if (this.selectedQuestion.value === 'Anders' && !this.otherSubject) {
        // subject 'Anders', but none given
        this.msg = { msg: 'Het bericht kan niet worden verzonden, vul A.U.B. een onderwerp in', type: 'error' };
      } else if (!this.message && mandatoryMessage) {
        // no message added
        this.msg = { msg: 'Het bericht kan niet worden verzonden, er is geen bericht', type: 'error' };
      } else if (this.contactOption.value === 'port') {
        // contacting from port
        this.sdk.portContact(
          this.message,
          this.contactOption.id,
          (response) => {
            if (response.status === 200) {
              this.msg = { msg: 'Uw bericht is ontvangen. Wij zullen deze zo snel mogelijk in behandeling nemen.', type: 'success' };
            } else if (response.status === 429) {
              this.msg = { msg: 'Te veel berichten verstuurd in de laatste minuut, probeer het over een paar minuten nog eens.', type: 'error' };
            } else if (response.status === 400) {
              this.msg = { msg: 'Het bericht kan niet worden verzonden, vul A.U.B. een onderwerp in.', type: 'error' };
            } else {
              this.msg = { msg: 'Bericht kan helaas niet verzonden worden, probeer het later opnieuw', type: 'error' };
            }
          },
          this.selectedQuestion.value === 'Anders' ? this.otherSubject : this.selectedQuestion.value,
        );
      } else if (this.contactOption.value === 'intake') {
        // contacting from intake
        this.sdk.intakeContact(
          this.message,
          this.contactOption.id,
          (response) => {
            if (response.status === 200) {
              this.msg = { msg: 'Uw bericht is ontvangen. Wij zullen deze zo snel mogelijk in behandeling nemen.', type: 'success' };
            } else if (response.status === 429) {
              this.msg = { msg: 'Te veel berichten verstuurd in de laatste minuut, probeer het over een paar minuten nog eens.', type: 'error' };
            } else if (response.status === 400) {
              this.msg = { msg: 'Het bericht kan niet worden verzonden, vul A.U.B. een onderwerp in.', type: 'error' };
            } else {
              this.msg = { msg: 'Bericht kan helaas niet verzonden worden, probeer het later opnieuw', type: 'error' };
            }
          },
          this.selectedQuestion.value === 'Anders' ? this.otherSubject : this.selectedQuestion.value,
        );
      } else {
        // general contact
        this.sdk.generalContact(
          this.message,
          (response) => {
            if (response.status === 200) {
              this.msg = { msg: 'Uw bericht is ontvangen. Wij zullen deze zo snel mogelijk in behandeling nemen.', type: 'success' };
            } else if (response.status === 429) {
              this.msg = { msg: 'Te veel berichten verstuurd in de laatste minuut, probeer het over een paar minuten nog eens.', type: 'error' };
            } else if (response.status === 400) {
              this.msg = { msg: 'Het bericht kan niet worden verzonden, vul A.U.B. een onderwerp in.', type: 'error' };
            } else {
              this.msg = { msg: 'Bericht kan helaas niet verzonden worden, probeer het later opnieuw', type: 'error' };
            }
          },
          this.selectedQuestion.value === 'Anders' ? this.otherSubject : this.selectedQuestion.value,
        );
      }
    },
    closeModal() {
      this.uploadForm = false;
      this.$emit('close');
      this.msg = { msg: null, type: 'notice' };
    },
  },
};
</script>
